import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="54" viewBox="-1 -1 34 56">
    <g fill="none" fillRule="evenodd">
      <g opacity=".495">
        <g>
          <g stroke="#536171" strokeWidth="1.5">
            <path
              d="M19.994 36.554v3.642c0 .892-.717 1.615-1.616 1.615h-4.847a1.611 1.611 0 0 1-1.615-1.615v-3.642a19.88 19.88 0 0 0 4.039.41 19.88 19.88 0 0 0 4.039-.41z"
              strokeWidth="1.211745"
            />
            <path
              d="M16.065 41.805s-1.615 10.884 6.471 4.622c8.087-6.262 6.59 6.959 6.59 6.959"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.211745"
            />
            <path
              d="M24.84 11.108V2.215c0-.887-.723-1.61-1.615-1.61-.898 0-1.615.721-1.615 1.61v8.893h3.23zM10.3 11.108V2.215c0-.887-.723-1.61-1.616-1.61-.898 0-1.615.721-1.615 1.61v8.893h3.23z"
              strokeWidth="1.211745"
            />
          </g>
          <g transform="translate(.606 9.896) scale(.80783)">
            <path
              d="M37.996 20.194c.003-.061.004-.122.004-.184V3.99A3.991 3.991 0 0 0 34.005 0H3.995A3.988 3.988 0 0 0 0 3.99v16.02c0 .062.001.123.004.184-.003.102-.004.204-.004.306C0 28.508 8.507 35 19 35s19-6.492 19-14.5c0-.102-.001-.204-.004-.306z"
              fill="#eef2f4"
              stroke="#536171"
              strokeWidth="1.5"
            />
            <path d="M25 23.143C25 20.303 22.314 18 19 18s-6 2.303-6 5.143h12z" fill="#536171" />
            <rect x="10" y="10" width="4" height="6" rx="8" fill="#536171" />
            <rect x="24" y="10" width="4" height="6" rx="8" fill="#536171" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/plug.es6.js